import {createSelector} from 'reselect';
const entity = 'Projects';

export const team = createSelector([state => state[entity].team.data], val => val);
export const meta = createSelector([state => state[entity].team.meta], val => val);
export const api = createSelector([state => state[entity].api], val => val);
export const isLoading = createSelector([state => state[entity].api.loading], val => val);
